import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import SglContext from "../SglContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";


const arrayMoveMutate = (array, from, to) => {
  const startIndex = from < 0 ? array.length + from : from;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = to < 0 ? array.length + to : to;

    const [item] = array.splice(from, 1);
    array.splice(endIndex, 0, item);
  }
};

const arrayMove = (array, from, to) => {
  array = [...array];
  arrayMoveMutate(array, from, to);
  return array;
};

const SortableItem = ({ ring, expanded, ...props }) => (
  <li className='drag_li'>
    <div className='div-responsive'>
      <div
        className='class-details, primary-header sgl-movable'
        expanded={expanded}>
        <p className='ring-name'>{ring.ring_name}</p>
        <div className='ring-arrow sgl-arrow'>
          <span
            className={props.setArrow(ring.ring_number)}
            onClick={props.handleExpandClick(ring.ring_number)}></span>
        </div>
        <div className='ring-arrow sgl-arrow'>
          <span>
            <Link
              to={
                "/ring/detail?ring_id=" +
                ring.ring_id +
                "&sid=" +
                props.current_show +
                "&s_date=" +
                props.show_date
              }>
              View Order
            </Link>
          </span>
        </div>
      </div>
      <div
        id={"header" + ring.ring_number}
        className={props.getHeaderExtendedClass(ring.ring_number)}>
        <table className='table table-hover'>
          <tbody>
            {ring.header_classes.length > 0 &&
              ring.header_classes.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <b>{data.interval}</b> {data.header}{" "}
                      {data.est_time && data.time !== "00:00:00" ? (
                        <b>Est. Start: </b>
                      ) : (
                        ""
                      )}
                      {data.est_time && data.time !== "00:00:00"
                        ? props.format_time(data.time)
                        : ""}
                    </td>
                  </tr>
                );
              })}
            {ring.show_header_message && (
              <tr>
                <td>No additional classes scheduled in this ring</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div
        id={"detail" + ring.ring_number}
        className={props.getExtendedClass(ring.ring_number)}>
        <table className='table table-striped table-hover'>
          <tbody>
            <tr className='sgl-primary-header'>
              <th>Class</th>
              <th>Est. Start</th>
              <th className='center-align'>Trips</th>
            </tr>
            {ring.active_ring_classes.map((active_class, index) => {
              return (
                <tr
                  key={index}
                  className={
                    (active_class.active_status ? "active-row" : "test") +
                    " sgl-anchor"
                  }>
                  {active_class.schedule_break ? (
                    <td>{active_class.group_name}</td>
                  ) : (
                    <td>
                      {active_class.group_name} (
                      {props.getClassIds(active_class.classes)} ) &nbsp;
                      {props.checkIsLive(
                        active_class.classes,
                        props.live_class_ids
                      ) ? (
                        <span className='live_class_badge'>Live</span>
                      ) : (
                        ""
                      )}
                    </td>
                  )}
                  {active_class.group_started ? (
                    active_class.actual_start_time != "00:00:00" ? (
                      <td>
                        {active_class.cancelled
                          ? "CANCELLED"
                          : props.format_time(active_class.actual_start_time)}
                      </td>
                    ) : (
                      <td>
                        {active_class.cancelled
                          ? "CANCELLED"
                          : props.format_time(active_class.actual_go_time)}
                      </td>
                    )
                  ) : (
                    <td>
                      {active_class.cancelled
                        ? "CANCELLED"
                        : props.show_planned_time
                        ? active_class.start_time_default != "00:00:00"
                          ? props.format_time(active_class.start_time_default)
                          : ""
                        : props.format_time(active_class.estimated_start_time)}
                    </td>
                  )}
                  <td className='center-align'>
                    {active_class.cancelled || active_class.schedule_break
                      ? " "
                      : active_class.completed_trips +
                        " of " +
                        active_class.total_trips}
                  </td>
                </tr>
              );
            })}
            {ring.upcoming_ring_classes_list.length > 0
              ? ring.upcoming_ring_classes_list.map(
                  (upcoming_class, index) => {
                    return (
                      <tr key={index} className='sgl-anchor'>
                        {upcoming_class.schedule_break ? (
                          <td>{upcoming_class.group_name}</td>
                        ) : (
                          <td>
                            {upcoming_class.group_name} ({" "}
                            {props.getClassIds(upcoming_class.classes)} ) &nbsp;
                            {props.checkIsLive(
                              upcoming_class.classes,
                              props.live_class_ids
                            ) ? (
                              <span className='live_class_badge'>Live</span>
                            ) : (
                              ""
                            )}
                          </td>
                        )}
                        <td>
                          {upcoming_class.cancelled
                            ? "CANCELLED"
                            : props.show_planned_time
                            ? upcoming_class.start_time_default != "00:00:00"
                              ? props.format_time(
                                  upcoming_class.start_time_default
                                )
                              : ""
                            : props.format_time(
                                upcoming_class.estimated_start_time
                              )}
                        </td>
                        <td className='center-align'>
                          {upcoming_class.cancelled ||
                          upcoming_class.schedule_break
                            ? " "
                            : upcoming_class.completed_trips +
                              " of " +
                              upcoming_class.total_trips}
                        </td>
                      </tr>
                    );
                  }
                )
              : ring.show_message && (
                  <tr>
                    <td>No additional classes scheduled in this ring</td>
                  </tr>
                )}
          </tbody>
        </table>
      </div>
    </div>
  </li>
);

const SortableList = SortableContainer((props) => {
  return (
    <ul className='drag_ul'>
      {props.rings.map((ring, index) => (
        <SortableItem
          {...props}
          key={`item-${ring.ring_number}`}
          onSortEnd={props.onSortEnd}
          index={index}
          ring={ring}
          expanded={0}
          settingIndex={index}
          setting={ring}
        />
      ))}
    </ul>
  );
});

export default function RingStatus(props) {
  // state = {
  //   facility_rings: [],
  //   show: {},
  //   shows_list: [],
  //   current_show: localStorage.getItem("show_id"),
  //   expanded_status: localStorage.getItem("ring_exp_status")
  //     ? JSON.parse(localStorage.getItem("ring_exp_status"))
  //     : {},
  //   rings_order: localStorage.getItem("rings_order")
  //     ? localStorage.getItem("rings_order")
  //     : "",
  //   show_days_list: [],
  //   show_date: "00/00/00",
  //   show_name: "",
  //   display_date: "",
  //   time_zone_date_time: {},
  //   live_class_ids: [],
  //   live_class_numbers: [],
  //   show_planned_time: false,
  //   loading: true,
  //   userData: {},
  // };

  const Sgl = useContext(SglContext);

  //API END POINTS
  const sgl_webservice_ring_status = Sgl.nestApiUrl + "/ring";
  const user_info_url = Sgl.nestApiUrl + "/users/getUser";

  const navigate = useNavigate();
  const [rings, set_rings] = useState([]);
  const [show, set_show] = useState({});
  const [current_show, set_current_show] = useState(
    localStorage.getItem("show_id")
  );
  const [expanded_status, set_expanded_status] = useState(
    localStorage.getItem("ring_exp_status")
      ? JSON.parse(localStorage.getItem("ring_exp_status"))
      : {}
  );
  const [rings_order, set_rings_order] = useState(
    localStorage.getItem("rings_order")
      ? localStorage.getItem("rings_order")
      : ""
  );
  const [show_days_list, set_show_days_list] = useState([]);
  const [show_date, set_show_date] = useState("00/00/00");
  const [show_name, set_show_name] = useState("");
  const [display_date, set_display_date] = useState("");
  const [time_zone_date_time, set_time_zone_date_time] = useState({});

  const [live_class_ids, set_live_class_ids] = useState([]);
  const [live_class_numbers, set_live_class_numbers] = useState([]);
  const [show_planned_time, set_show_planned_time] = useState(false);
  const [loading, set_loading] = useState(true);
  const [userData, set_userData] = useState({});
  const latestRequestRef = useRef(0);

  function onSortEnd({ oldIndex, newIndex }) {
    var ordered_rings = arrayMove(rings, oldIndex, newIndex);
    set_rings(ordered_rings);

    var ordered_ring_ids = ordered_rings.map((ring) => ring.ring_number);
    localStorage.setItem("rings_order", ordered_ring_ids);
  }
  useInterval(() => {
    getRingStatusData(show_date, current_show);
  }, 60000);

  useEffect(() => {
    localStorage.setItem("show_id", localStorage.getItem("show_id"));
    set_current_show(localStorage.getItem("show_id"));
    
    let current_date = show_date;
    if(props.current_show != current_show && props.current_show != 0 && current_show != 0 && !loading) {
      set_show_date("00/00/00")
        updateSearchParam( 'date' , '' )
        updateSearchParam( 'sid' , '' )
        current_date = "00/00/00"
    }
    if (loading) {
        current_date = getQueryVariable("date") ? getQueryVariable("date"): "00/00/00"
        set_show_date(current_date);
    }
    getRingStatusData(current_date, localStorage.getItem("show_id"));
  }, [props.current_show]);

  useEffect(() => {
    var _show_date = getQueryVariable("date")
      ? getQueryVariable("date")
      : show_date;
    var _current_show = getQueryVariable("sid")
      ? getQueryVariable("sid")
      : current_show;

    set_show_date(_show_date);

    set_current_show(_current_show);
    getAllData(_show_date, _current_show);
    
  }, [show_date, current_show, display_date]);

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  function getRingStatusData(show_date, show) {
    const requestId = ++latestRequestRef.current;
    axios
      .get(sgl_webservice_ring_status, {
        params: {
          show_date: show_date,
          show_id: show,
          customer_id: Sgl.company_id,
        },
      })
      .then((results) => {
        if (requestId === latestRequestRef.current) {
          var rings = results.data.rings;
          var ring_ids = localStorage.getItem("rings_order");

          if (ring_ids) {
            ring_ids = ring_ids.split(",").map((x) => +x);
            rings.sort(function (a, b) {
              return (
                ring_ids.indexOf(a.ring_number) - ring_ids.indexOf(b.ring_number)
              );
            });
          }
          set_show(results.data.show);
          updateSearchParam( 'sid' , results.data.show_id )
          updateSearchParam( 'date' , results.data.show_date )
          set_rings(rings ? rings : []);
          set_current_show(results.data.show_id);
          // set_current_show(current_show);

          set_show_name(results.data.show.show_name);
          set_show_days_list(results.data.show_days_list);
          set_show_date(results.data.show_date);
          set_display_date(results.data.display_date);
          set_time_zone_date_time(results.data.time_zone_date_time);
          set_show_planned_time(results.data.show_planned_time);
          getLiveClasses();
          document.title =
            "Ring status for " + show_name + " (" + display_date + ")";
          Sgl.reportToGA(
            "/sgl-wp-plugin/" +
              Sgl.company_urlpath +
              "/" +
              show +
              "/ring/list/" +
              show_date
          );
          Sgl.reportToFB(
            "/sgl-wp-plugin/" +
              Sgl.company_urlpath +
              "/" +
              show +
              "/ring/list/" +
              show_date
          );
        }
        set_loading(false);
      });
  }

  function getAllData(show_date, show) {
    getUserData();

    axios
      .all([
        axios.get(sgl_webservice_ring_status, {
          params: {
            show_date: show_date,
            show_id: show,
            customer_id: Sgl.company_id,
          },
        })
      ])
      .then(
        axios.spread((results) => {
          var rings = results.data.rings;
          var ring_ids = localStorage.getItem("rings_order");

          if (ring_ids) {
            ring_ids = ring_ids.split(",").map((x) => +x);
            rings.sort(function (a, b) {
              return (
                ring_ids.indexOf(a.ring_number) - ring_ids.indexOf(b.ring_number)
              );
            });
          }
          set_show(results.data.show);
          set_rings(rings);
          set_current_show(results.data.show_id);
          // set_current_show(current_show);
          set_show_name(results.data.show.show_name);
          set_show_days_list(results.data.show_days_list);
          set_show_date(results.data.show_date);
          set_display_date(results.data.display_date);
          set_time_zone_date_time(results.data.time_zone_date_time);
          set_show_planned_time(results.data.show_planned_time);
          getLiveClasses();
          document.title =
            "Ring status for " + show_name + " (" + display_date + ")";
          Sgl.reportToGA(
            "/sgl-wp-plugin/" +
              Sgl.company_urlpath +
              "/" +
              results.data.show_id +
              "/ring/list/" +
              results.data.show_date
          );
          Sgl.reportToFB(
            "/sgl-wp-plugin/" +
              Sgl.company_urlpath +
              "/" +
              results.data.show_id +
              "/ring/list/" +
              results.data.show_date
          );
          set_loading(false);
        })
      );
  }

  function setRingExpStatus() {
    var ring_statuses = JSON.parse(localStorage.getItem("ring_exp_status"));
    var ring_status_list = {};
    if (ring_statuses == null || ring_statuses == {}) {
      if (rings && rings.length > 0) {
        for (var i = 0; i < rings.length; i++) {
          var ring_number = rings[i]["ring_number"];
          ring_status_list[ring_number] = "0";
        }
        localStorage.setItem(
          "ring_exp_status",
          JSON.stringify(ring_status_list)
        );
      }
    }
  }

  const updateSearchParam = ( paramkey , paramValue ) => {
    if ( !paramkey ) {
      return
    }

    var searchParams = new URLSearchParams(window.location.search)
    if ( paramValue == '' ) {
      searchParams.delete( paramkey )
    } else {
      searchParams.set( paramkey, paramValue)
    }
    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    window.history.pushState(null, '', newRelativePathQuery);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
      canonical.href = window.location.href;
    }
  }

  function appendDateToURL(date) {
    var url = window.location.href,
      newurl;
    if (url.search("&date=") > 0) {
      newurl = url.replace(/&date=(.*)/, "&date=" + date);
    } else if (url.indexOf("?date=") > 0) {
      newurl = url.replace(/[?]date=(.*)/, "?date=" + date);
    } else {
      newurl = url + (url.indexOf("?") > 0 ? "&" : "?") + "date=" + date;
    }
    window.history.pushState(date, "", newurl);
  }

  function openTab(tabName) {
    return function (e) {
      updateSearchParam( 'date' , tabName )
      var i, tablinks;

      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      e.currentTarget.className += " active";
      set_show_date(e.currentTarget.id);
      getRingStatusData(e.currentTarget.id, current_show);
    };
  }
  function format_time(timeString) {
    if (timeString) {
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = H < 12 || H === 24 ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }
    return;
  }
  function setArrow(ring_number) {
    var ring_statuses = JSON.parse(localStorage.getItem("ring_exp_status"));

    let className = "direction";
    var status = ring_statuses[ring_number];

    className += status === "1" ? " asc" : " desc";
    return className;
  }

  function getExtendedClass(ring_number) {
    var ring_statuses = JSON.parse(localStorage.getItem("ring_exp_status"));

    var status = ring_statuses[ring_number];

    return status === "1" ? "expanded" : "unexpanded";
  }

  function getHeaderExtendedClass(ring_number) {
    var ring_statuses = JSON.parse(localStorage.getItem("ring_exp_status"));

    var status = ring_statuses[ring_number];

    return status === "0" ? "expanded" : "unexpanded";
  }

  function handleExpandClick(ring_number) {
    return function (e) {
      var ring_statuses = JSON.parse(localStorage.getItem("ring_exp_status"));
      var status = ring_statuses[ring_number];
      status = status === "1" ? "0" : "1";
      ring_statuses[ring_number] = status;
      localStorage.setItem("ring_exp_status", JSON.stringify(ring_statuses));

      if (status === "0") {
        document.getElementById("header" + ring_number).style.display = "block";
        document.getElementById("detail" + ring_number).style.display = "none";
      } else {
        document.getElementById("header" + ring_number).style.display = "none";
        document.getElementById("detail" + ring_number).style.display = "block";
      }

      let className = "direction";
      className += status === "1" ? " asc" : " desc";
      e.currentTarget.className = className;
    };
  }

  function getClassIds(classes) {
    const array = [];

    for (var i = 0; i < classes.length; i++) {
      array.push(
        <Link
          to={
            "/classes/detail?cid=" +
            classes[i]["class_id"] +
            "&sid=" +
            current_show
          }>
          &nbsp;{classes[i]["class_number"]}
        </Link>
      );
    }
    return array;
  }
  function getLiveClasses() {
    var timestamp = Date.now();
    axios
      .post(
        Sgl.sglApiUrl +
          "/iphone.php/" +
          Sgl.company_urlpath +
          "/webservice/LiveScoreWidget",
        {
          datetimestamp: timestamp,
          customer_id: Sgl.company_id,
          from_wp_api: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        var live_class_ids = [];
        var live_class_numbers = [];

        if (Object.keys(res.data).length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            var show_data = res.data[i];
            // const live_rings = show_data["live_data"];
            const rings = Object.keys(res.data[i]["live_data"]);

            if (
              rings &&
              rings.length > 0 &&
              show_data.show_id == current_show
            ) {
              rings.forEach((key, index) => {
                let ring = res.data[i]["live_data"][key];
                if (ring.livenow && ring.livenow.length > 0) {
                  ring.livenow.forEach((class_group, index) => {
                    if (class_group.is_live) {
                      live_class_ids = live_class_ids.concat(
                        class_group.classes
                      );
                      live_class_numbers = live_class_numbers.concat(
                        class_group.classNumbers
                      );
                    }
                  });
                }
              });
            }
          }
        }
        set_live_class_ids(live_class_ids);
        set_live_class_numbers(live_class_numbers);
      });
  }
  function checkIsLive(classes, live_class_ids) {
    var class_number_list = [];

    for (var i = 0; i < classes.length; i++) {
      class_number_list.push(classes[i]["class_id"]);
    }
    // var class_number_list = class_nums.split(',');
    return live_class_ids.some((item) =>
      class_number_list.includes(Number(item))
    );
  }

  function getUserData() {
    axios.get(user_info_url).then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          set_userData(response.data.user);
        } else {
        }
      },
      (error) => {}
    );
  }

  function shouldCancelStart(e) {
    // Cancel sorting if the event target is an anchor tag (`a`) or span tag
    if (
      e.target.tagName.toLowerCase() === "a" ||
      e.target.tagName.toLowerCase() === "span"
      // e.target.tagName.toLowerCase() === "td"
    ) {
      return true; // Return true to cancel sorting
    }
  }

  // setRingExpStatus();
  if (loading) {
    return null;
  }

  if (localStorage.getItem("ring_exp_status") === null) {
    setRingExpStatus();
  }

  return (
    <div className='sgl-content-wrapper'>
      <div>
      <section className="search-area section-to-print">
        <h2 className="sgl-h2">
          Ring status for {show_name} ({display_date})
        </h2>
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
        <br />
        <div className='tab'>
          {show_days_list.map((day, index) => {
            const default_tab = show_date === day.date ? " active" : "";
            return (
              // <Tooltip title="Delete">
              <button
                key={index}
                className={["tablinks", "element", default_tab].join(" ")}
                onClick={openTab(day.date)}
                id={day.date}>
                {day.day}
                {/* <span className="tooltip">I appear on hover!</span> */}
              </button>
              // </Tooltip>
            );
          })}
          <div className='ring-arrow'>
            <span className='sponsor_text'>
              Updated: {time_zone_date_time.date} as of{" "}
              {time_zone_date_time.time}
            </span>
          </div>
        </div>
        <div id='ringWrapper' className='ringWrapper'>
          <SortableList
            rings={rings}
            current_show={current_show}
            show_date={show_date}
            handleExpandClick={handleExpandClick}
            setArrow={setArrow}
            getHeaderExtendedClass={getHeaderExtendedClass}
            format_time={format_time}
            getExtendedClass={getExtendedClass}
            getClassIds={getClassIds}
            checkIsLive={checkIsLive}
            onSortEnd={onSortEnd}
            live_class_ids={live_class_ids}
            // distance={1}
            show_planned_time={show_planned_time}
            shouldCancelStart={shouldCancelStart}
            // pressDelay={100}
          />
        </div>
        <div className='copyright-text'>
          {" "}
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
        </section>
      </div>
    </div>
  );
}

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}